export const buildPayload = (data) => ({
  code: data.code,
  name: data.name,
  address: data.address,
  brokerId: data.brokerId?.id,
  state: data.stateId?.stateId,
  active: data.active,
  live: data.live !== undefined ? data.live : false,
  aiSummaryEnabled: data.aiSummaryEnabled !== undefined ? data.aiSummaryEnabled : false,
  campaignEnabled:
    data.campaignEnabled !== undefined ? data.campaignEnabled : false,
  filtersEnabled: data.filtersEnabled !== undefined ? data.filtersEnabled : true,
  dateBasisEnabled: data.dateBasisEnabled !== undefined ? data.dateBasisEnabled : true,
  dateRangeEnabled: data.dateRangeEnabled !== undefined ? data.dateRangeEnabled : true,
  rolling12Enabled: data.rolling12Enabled !== undefined ? data.rolling12Enabled : true,
  planYTDVsPriorPlanYTDEnabled:
    data.planYTDVsPriorPlanYTDEnabled !== undefined ? data.planYTDVsPriorPlanYTDEnabled : true,
  planYTDVsPriorPlanYearEnabled:
    data.planYTDVsPriorPlanYearEnabled !== undefined ? data.planYTDVsPriorPlanYearEnabled : true,
  customRangeEnabled: data.customRangeEnabled !== undefined ? data.customRangeEnabled : true,
  divisionsEnabled: data.divisionsEnabled !== undefined ? data.divisionsEnabled : true,
  plansEnabled: data.plansEnabled !== undefined ? data.plansEnabled : true,
  cohortBuilderEnabled: data.cohortBuilderEnabled !== undefined ? data.cohortBuilderEnabled : true,
  phiCohortBuilderEnabled:
    data.phiCohortBuilderEnabled !== undefined ? data.phiCohortBuilderEnabled : false,
  renewalAccountType: data.renewalAccountType.value
});
